module.exports = __webpack_public_path__ + "img/704.1d25dab5.jpg";